// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  wild: {
    animals_involved: 'Animals Involved',
    ai_insights: 'AI Insights',
    dashboard: 'Dashboard',
    claims_manager: 'Claims Manager',
    reviewed_claims: 'Reviewed Claims',
    analyst_claims: 'Analyst Claims',
    approved_claims: 'Approved Claims',
    all_claims: 'All Claims',
    user_manager: 'User Manager',
    cvo_locator: 'CVO Locator',
    species_filters: 'Species Filters',
    incident_details: 'Incident Details',
    view_full_claim: 'View Full Claim',
    ecological_analysis: 'Ecological Analysis',
    real_time_insights: 'Real-time map insights',
    select_marker: 'Select a marker to view details',
    generating: 'Generating…',
    regenerate: 'Regenerate',
    generate_insights: 'Generate Insights',
    click_generate: 'Click Generate Insights to analyse the current data with AI.',
    analysing: 'Analysing data…',
    confidence_rating: 'Confidence Rating',
    ai_verification_score: 'AI Verification Score',
    insight_history: 'Insight History',
    previous_shared_reports: 'Previous shared reports for',
    // Analytics
    welcome_back: 'Hi, Welcome back',
    total_claims: 'Total Claims',
    under_review: 'Under Review',
    pending_cvo: 'Pending CVO',
    pending_analysis: 'Pending Analysis',
    avg_review_time: 'Avg Review Time',
    paid_claims: 'Paid Claims',
    paid_zmw: 'Paid (XAF)',
    pending_payment_zmw: 'Pending (XAF)',
    claims_by_category: 'Claims by category',
    start_date: 'Start Date',
    end_date: 'End Date',
    gma_ward: 'Province/Department',
    // Status
    status: {
      all: 'All',
      assigned: 'Assigned',
      acknowledged: 'Acknowledged',
      travel: 'Travel',
      onsite: 'Onsite',
      checklist_submitted: 'Checklist Submitted',
      initial_review: 'Initial Review',
      approved: 'Approved',
      rejected: 'Rejected',
      deferred: 'Deferred',
      complete: 'Complete',
      payment_processing: 'Payment Processing',
      defer_analyst: 'Defer Analyst',
      completed: 'Completed',
      payment_failed: 'Payment Failed',
      partially_paid: 'Partially Paid',
    },
    // Table Headers
    table: {
      reference: 'Reference',
      nature_of_claim: 'Nature of Claim',
      gma: 'Province',
      village: 'Village',
      claimant_names: 'Claimant Full Names',
      nrc_no: 'Claimant National ID',
      date: 'Date',
      status: 'Current Status',
      assigned_cvo: 'Assigned CVO',
      amount: 'Claim Amount (XAF)',
      claim_amount_zmw: 'Claim Amount (ZMW)',
      download_csv: 'Download CSV',
      phone_no: 'Phone Number',
      date_time: 'Date & Time',
      approved_amount: 'Approved Amount',
      approver_comments: 'Approver Comments',
      payment_mode: 'Payment Mode',
      account_name: 'Account Name',
      account_number: 'Account Number',
      transaction_amount_zmw: 'Transaction Amount (ZMW)',
      amount_zmw: 'Amount (ZMW)',
      disbursement_note: 'Disbursement Note',
      name: 'Name',
      email: 'Email',
      county: 'County',
      sub_county: 'Sub County',
      ward: 'Ward',
      role: 'Role',
      claimant_age: 'Claimant Age',
      claimant_gender: 'Claimant Gender',
    },
    // Interaction
    confirm_approve: 'Confirm Task Approval',
    confirm_reject: 'Confirm Task Rejection',
    confirm_defer: 'Confirm Task Deferral',
    are_you_sure: 'Are you sure you want to',
    view: 'View',
    edit_assign: 'Edit/Assign',
    delete: 'Delete',
    // Categories
    'Human death': 'Human death',
    'Crop damage': 'Crop damage',
    'Livestock predation': 'Livestock predation',
    'Property damage': 'Property damage',
    'Human injury': 'Human injury',
    occurence_date: 'Occurence Date',
    task_name: 'Task Name',
    address: 'Address',
    cvo_note: 'CVO Note',
    claimant_details: 'Claimant Details',
    ussd_phone: 'USSD Phone Number',
    assigned_to: 'Assigned To',
    next_of_kin: 'Next Of Kin',
    national_id: 'National ID',
    payment_details: 'Payment Details',
    analyst_status: 'Analyst Status',
    admin_status: 'Admin Status',
    verified: 'Verified',
    unverified: 'Unverified',
    'Task Checklist': 'Task Checklist',
    nature_of_claim: 'Nature of Claim',
    claimant_location: 'Claimant Location',
    claimant_age: 'Claimant Age',
    claimant_gender: 'Claimant Gender',
    extent_of_damage: 'Extent of Damage',
    statement_claimant: 'Statement from Claimant',
    statement_witness: 'Statement from Witness',
    land_acreage: 'Land Acreage',
    crop_destroyed: 'Crop Destroyed',
    approx_land_destroyed: 'Approximate Land Destroyed',
    growth_state: 'State of Growth',
    estimated_value_crops: 'Estimated Value of Crops',
    estimated_quantity_crops_per_acre: 'Estimated Quantity of Crops Per Acre',
    estimated_value_crop_per_acre: 'Estimated Value of Crop Per Acre',
    percentage_crop_loss: 'Percentage of Crop Loss',
    livestock_type: 'Livestock Type',
    number_dead: 'Number of livestock dead',
    number_injured: 'Number of livestock injured',
    estimated_value_loss: 'Estimated Value of Loss',
    description_property: 'Description of Property Damaged',
    estimated_value_property: 'Estimated Value of Property',
    description_predation_area: 'Description of Area of Predation',
    animal_identification_details: 'Animal Identification Details',
    animal_age_sex_breed: 'Animal Age, Sex and Breed',
    description_predation_occurrence: 'Description of Predation Occurrence',
    injured_surviving_animal_description: 'Description of Injured or Surviving Animal',
    animal_health_condition: 'Animal Health Condition',
    items_damaged: 'Items Damaged',
    description_damage: 'Description of Damage',
    estimated_cost_repair: 'Estimated Cost of Repair',
    maintenance_records: 'Maintenance Records',
    ownership_evidence: 'Ownership Evidence',
    repair_quotes: 'Repair Quotes',
    cvo_findings: 'CVO Findings',
    cvo_recommendations: 'CVO Recommendations',
    investigator_findings: 'Investigator Findings',
    investigator_recommendations: 'Investigator Recommendations',
    investigator_amount_estimate: 'Investigator Amount Estimate',
    appearance_injuries_description: 'Description of Appearance of Injuries',
    nature_injuries_description: 'Description of Nature of Injuries',
    patient_under_advice_description: 'Description of Patient Under Medical Advice',
    commencement_total_disability: 'Commencement of Total Disability',
    mitigation_measure_in_place: 'Mitigation Measure in Place',
    efficiency_mitigation: 'Efficiency of Mitigation',
    date_incident: 'Date of Incident',
    description_predator: 'Description of Predator',
    chronology_events: 'Chronology of Events',
    salvageable_items: 'Salvageable Items',
    gps_location_incident: 'GPS Location of Incident',
    circumstance_injury_occurrence: 'Circumstances of Injury Occurrence',
    residence_address: 'Place of Residence Address',
    residence_post_code: 'Place of Residence Post Code',
    residence_assistant_chief: 'Place of Residence Assistant Chief',
    residence_location: 'Place of Residence Location',
    residence_chief: 'Place of Residence Chief',
    residence_division: 'Place of Residence Division',
    employer_name: 'Employer Name',
    employer_nature_business: 'Employer’s Nature of Business',
    employer_salary: 'Employer’s Salary',
    injury_duration: 'Duration of Injury',
    consultation_date: 'Consultation Date',
    percentage_incapacity: 'Percentage of Incapacity',
    police_ob_number: 'Police OB Number',
    police_comments: 'Police Comments',
    police_recommendations: 'Police Recommendations',
    files: 'Files',
    details: 'Details',
    files_uploaded: 'Files uploaded: {{count}}',
    add_files: 'Add Files',
    no_files_found: 'No Files Found',
    add_checklist_files: 'Add Checklist Files',
    task_approved_successfully: 'Task approved successfully!',
    task_approval_failed: 'Failed to approve task.',
    task_deferred_successfully: 'Task deferred successfully!',
    task_deferral_failed: 'Failed to defer task.',
    task_rejected_successfully: 'Task rejected successfully!',
    task_rejection_failed: 'Failed to reject task.',
    task_reviewed_successfully: 'Task reviewed successfully!',
    task_review_failed: 'Failed to review task.',
    payment_initiated_successfully: 'Payment initiated successfully!',
    payment_initiation_failed: 'Failed to initiate payment.',
    task_completed_successfully: 'Task completed successfully!',
    task_completion_failed: 'Failed to complete task.',
    process_payment: 'Process Payment',
    approve_task: 'Approve Task',
    reject_task: 'Reject Task',
    fraud_analysis_claim_estimator: 'Fraud Analysis & Claim Estimator',
    standardized_payouts_discrepancies: 'Calculates standardized payouts and highlights discrepancies',
    checklist_required_for_ai_analysis: 'No checklist data available. A checklist must be submitted for AI analysis.',
    standardized_crop_compensation: 'Standardized Crop Compensation',
    not_valid: 'Not valid',
    damaged_land: 'Damaged land',
    photo_evidence: 'Photo evidence',
    calculation_basis: 'Basis',
    minimum_claim: 'Minimum claim',
    rate_per_damaged_hectare: '{{rate}} ZMW per damaged hectare',
    task_status_timeline: 'Task Status Timeline',
    status_change_timeline: 'A timeline of status changes',
    confirm_initial_review: 'Confirm Task Initial Review',
    defer: 'Defer',
    submit_review: 'Submit Review',
    confirm_task_payment: 'Are you sure you want to pay {{taskName}}?',
    complete_task: 'Complete Task',
    claims: 'Claims',
    all_users: 'All Users',
    new_user: 'New User',
    approve: 'Approve',
    approve_tasks: 'Approve Tasks',
    process_payments: 'Process Payments',
    confirm_tasks_payment_processing: 'Confirm Tasks Payment Processing',
    tasks_updated_successfully: 'Tasks updated successfully!',
    tasks_update_failed: 'Failed to update tasks.',
    confirm_delete_items: 'Are you sure you want to delete {{count}} items?',
    confirm_approve_task_name: 'Are you sure you want to approve task {{taskName}}?',
    confirm_reject_task_name: 'Are you sure you want to reject task {{taskName}}?',
    confirm_selected_tasks_payment: 'Are you sure you want to pay the selected tasks?',
    update_payment_status_for: 'Update Payment Status for: {{taskName}}',
    user_delete_success: 'User deleted successfully!',
    deletion_failed: 'Deletion failed.',
    confirm_delete_user: 'Are you sure you want to delete {{firstName}} {{lastName}}?',
    reset_password: 'Reset Password',
    search: 'Search…',
    clear: 'Clear',
    update_payment: 'Update Payment',
    domestic_animal: 'Domestic Animal',
    dead_livestock: 'Dead Livestock',
    injured_livestock: 'Injured Livestock',
  },
};

export default en;
